/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 21:45:41
 * @LastEditTime: 2019-09-10 10:46:04
 * @LastEditors: Please set LastEditors
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* 写在前面
 * 用户信息相关的都是后端url上拼接，不需要再和App交互
 * 对于设置标题等等别的交互，用的都是4.2.0中的新的交互
 */

import Vue from 'vue'
import App from './App'
import router from './router'
import storage from 'storejs'
import { createUuid, getUrlParam} from './../src/utils/common'
import store from './store'
// import { authAddUserInfo, addUserInfo, getUserInfo } from "./../src/server/account/account";
import { getActivityInfo } from './../src/server/common/common'
import system from './utils/checkSystem.js'
import { Lazyload, Toast, InfiniteScroll } from 'mint-ui'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import { wxShare } from './../src/utils/wxShare'
import { setShareInfo, setTitle, hideShareBtn } from './../src/utils/JSbridge'
// import encode from "./server/api/encode";
import { versionDiff } from './utils/versionDiff'
import dateformat from 'dateformat'
import time from './utils/time.js'
import { oauthOpenid } from './server/account/account'

// 神策埋点 start
import sa from 'sa-sdk-javascript'
import './utils/manulTrack' // 通过自定义指令实现给动态dom添加手动埋点监听的功能
import $ from 'jquery'
import echarts from 'echarts'
import "./../node_modules/echarts/map/js/china.js"; // 引入中国地图数据
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(Lazyload)
Vue.use(InfiniteScroll)
time()
// 兼容es6
require('es6-promise').polyfill()
Es6Promise.polyfill()
// 公共的弹窗样式
Vue.prototype.toast = function (msg, type) {
  if (type) {
    if (type === 'success') {
      window.toastName = Toast({
        message: msg,
        iconClass: 'icon iconfont icon-wancheng'
      })
      return window.toastName
    } else if (type === 'error') {
      window.toastName = Toast({
        message: msg,
        iconClass: 'icon iconfont icon-huabanfuben'
      })
      return window.toastName
    } else {
      window.toastName = Toast(msg)
      return window.toastName
    }
  } else {
    window.toastName = Toast(msg)
    return window.toastName
  }
}

/** 神策初始化 */
sa.init({
  server_url: window.saUrl,
  //  http://47.100.226.93:8106/sa?project=production
  heatmap: {
  // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'default',
    // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
    scroll_notice_map: 'default',
    is_single_page: true
  }
})
console.log(sa.store.getDistinctId())
console.log(sa.store.getFirstId())

// 判断uuid缓存是否存在，不存在则重新生成
var getUuid = storage('uuid')
if (!getUuid) {
  getUuid = createUuid()
  storage('uuid', getUuid)
}
window.uuid = getUuid
console.log('ACTIVITY', ACTIVITY)
/* eslint-disable no-new */
console.log(2222222222, system())
store.state.system = system()
store.state.isWeChat = /MicroMessenger/i.test(navigator.userAgent)
store.state.user.uid = storage('uid')
/** 获取页面url信息 */
/* let urlChannel = getUrlParam('channel')  // 页面来源区分
if (urlChannel) {
  store.state.channel = urlChannel
} else {
  store.state.channel = 8 // 默认微信好友分享
}

let urlFrom = getUrlParam('from')  // 针对微信分享，区分朋友圈  和 好友
if (urlFrom && (urlFrom === 'singlemessage'|| urlFrom === 'groupmessage')) { // 好友、群组
  store.state.channel = 8
} else if (urlFrom && urlFrom === 'timeline') { // 朋友圈
  store.state.channel = 9
} */
console.log(router)
store.state.type = getUrlParam('type') // 页面的类型
store.state.user.version = getUrlParam('version') // APP的版本
console.log(versionDiff(store.state.user.version, '4.2.0'), 'versionDiff')

// vue在ios端键盘弹起底部空白
// Start
console.log('checkSystem', system() == 'ios')
if (system() == 'ios') {
  $(document).on('focusin', function () {
    let lengths = $('.changeHeight').height()
    let val = lengths + 500
    $('.changeHeight').height(val)
  })
  $(document).on('focusout', function () {
    let lengths = $('.changeHeight').height()
    let val = lengths - 500
    $('.changeHeight').height(val)
  })
}
router.beforeEach((to, from, next) => {
  // 判断是否需要授权
  let lastUrl = window.location.href.split('#')[1]
  let newUrl= window.web_Url + '/commonProject/wuhanActivity/index.html?tempJSInteractionFlag=v1#'+lastUrl

  let authUrl='https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + window.appId + '&redirect_uri=' + encodeURIComponent(newUrl) + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'


  if (store.state.isWeChat && to.meta.needAuthorization) { // 需要授权
    let wxCode = getUrlParam('code')
    let openid = storage('wuhanOpenid')   
    
    if (!openid&&!wxCode) { // 无openid 和 code  去授权
      location.replace(authUrl)
    } else if(!openid && wxCode) { // 授权来的 查询用户信息
      console.log(wxCode,'wxCode')
      let data = { appid:window.appId,code:wxCode};
      oauthOpenid(data)
      .then(res=>{
        console.log(res)
        storage('wuhanOpenid', res.openid)
        next()
      })
      .catch(res=>{
        console.log(res)
        console.log('授权失败')
        location.replace(authUrl)
      })
      
    }else{
      next()
    }
    
  } else {
    sa.login(store.state.user.uid ? store.state.user.uid : sa.store.getDistinctId())
    next()
  }
})
// End
router.afterEach((to, from) => {
  document.title = to.meta.title
  window.scrollTo(0, 0)
  sa.quick('autoTrackSinglePage', {
    // $screen_name: to.meta.buriedTitle,
    // activityId: userInfo.activityId,
    // activityChannel: store.state.channel
  })
})
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})
/* const shareConfig = {
  link: window.web_Url + '/commonProject/wuhanActivity/index.html?tempJSInteractionFlag=v1#/home',
  title: '医学界·新冠肺炎疫情实时追踪',
  desc: '最新最全疫情进展|医学界医生站',
  imgUrl: 'https://studioyszimg.yxj.org.cn/1579594272632.jpg'
}
console.log(shareConfig)
if (!/MicroMessenger/i.test(navigator.userAgent)) { // 非微信
  console.log('非微信')
  hideShareBtn(false)
  shareInfo_new(shareConfig)
  setShareInfo(shareConfig, (res1) => {
  })
} else { // 微信环境
  console.log('微信')
  wxShare(shareConfig, (res1) => {
  })// 初始化微信分享
} */



// WEBPACK FOOTER //
// ./src/main.js